import { FC, useState, useEffect } from 'react'
import { Modal, Input } from 'antd'

interface ImportModalProps {
  visible: boolean
  onCancel: () => void
  onOK: (ids: string[]) => void
}

const ImportModal: FC<ImportModalProps> = ({ visible, onCancel, onOK }) => {
  const [ids, setIds] = useState<string>('')
  const okHandler = () => {
    const idList = ids.split('\n').filter(Boolean)
    idList.length && onOK?.(idList)
  }
  const onChange = e => {
    setIds(e.target.value.replace(' ', '').replace(/(\n)\1+/g, '\n'))
  }

  useEffect(() => {
    !visible && setIds('')
  }, [visible])

  return (
    <Modal title="导入" width="60%" visible={visible} onCancel={onCancel} onOk={okHandler}>
      <Input.TextArea
        autoSize
        onChange={onChange}
        value={ids}
        placeholder="输入标品Product ID，每行一个Product ID，不可空行"
      />
    </Modal>
  )
}

export default ImportModal